var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCardConsumption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#F0FDEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M21.9983 32.5599C16.166 32.5599 11.4383 27.8322 11.4383 21.9999C11.4383 16.1676 16.166 11.4399 21.9983 11.4399C27.8306 11.4399 32.5583 16.1676 32.5583 21.9999C32.5583 27.8322 27.8306 32.5599 21.9983 32.5599ZM18.3023 24.1119V26.2239H20.9423V28.3359H23.0543V26.2239H24.1103C24.8104 26.2239 25.4819 25.9458 25.977 25.4507C26.4721 24.9556 26.7503 24.2841 26.7503 23.5839C26.7503 22.8837 26.4721 22.2122 25.977 21.7171C25.4819 21.222 24.8104 20.9439 24.1103 20.9439H19.8863C19.7462 20.9439 19.6119 20.8883 19.5129 20.7892C19.4139 20.6902 19.3583 20.5559 19.3583 20.4159C19.3583 20.2759 19.4139 20.1416 19.5129 20.0425C19.6119 19.9435 19.7462 19.8879 19.8863 19.8879H25.6943V17.7759H23.0543V15.6639H20.9423V17.7759H19.8863C19.1861 17.7759 18.5146 18.054 18.0195 18.5491C17.5244 19.0442 17.2463 19.7157 17.2463 20.4159C17.2463 21.1161 17.5244 21.7876 18.0195 22.2827C18.5146 22.7778 19.1861 23.0559 19.8863 23.0559H24.1103C24.2503 23.0559 24.3846 23.1115 24.4836 23.2105C24.5827 23.3096 24.6383 23.4439 24.6383 23.5839C24.6383 23.7239 24.5827 23.8582 24.4836 23.9572C24.3846 24.0563 24.2503 24.1119 24.1103 24.1119H18.3023Z",
    fill: "#38993B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardConsumption);
export default __webpack_public_path__ + "static/media/iconCardConsumption.5532188ad9d62fc786ac3ed5c0deb40b.svg";
export { ForwardRef as ReactComponent };